
import Header1 from './Header1';
import Popup from './Popup2';
import "../styles/grid.css";
import Vector from "../assets/svg/editIcon.svg";
import Delete from "../assets/svg/DeleteIcon.svg";
import { useState, useRef, useEffect } from "react";
import DatePicker from "../Component/DatePicker";

const SubCostElement = () => {
  const tableData = [
    { id: 1, code: "ABC123", name: "John Doe", subCategory: "", date: "2025-02-26" },
    { id: 2, code: "XYZ456", name: "Jane Doe", subCategory: "", date: "2025-02-27" },
    { id: 3, code: "LMN789", name: "Alice", subCategory: "", date: "2025-02-28" },
  ];

  const handleDateSelection = (date) => {
    console.log("Selected Date:", date);
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const popupRef = useRef(null);

  const isAllSelected = selectedRows.length === tableData.length;
  const isAnySelected = selectedRows.length > 0;

  const handleAddNewClick = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
    };

    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  const handleSelectAll = () => {
    setSelectedRows(isAllSelected ? [] : tableData.map((row) => row.id));
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleDelete = () => {
    alert(`Deleting rows: ${selectedRows.join(", ")}`);
  };

  return (
    <>
      <Header1 />
      <div className="container">
        <div className="header">
          <div className="left-header">
            <h3>All Sub Category (50)</h3>
          </div>
          <div className="right-header">
            {!isAnySelected ? (
              <>
           <DatePicker onDateChange={handleDateSelection} />

                 <h4>Sort by :</h4>
                    <div className="dropdown">
                        <select id="options" className="dropdown-select">
                            <option value="option1">Date Created</option>
                            <option value="option2">Option 2</option>
                            <option value="option3">Option 3</option>
                        </select>
                    </div>
              </>
            ) : (
              <button id="deleteBtn" className="deleteBtn" onClick={handleDelete}>
                Delete
              </button>
            )}
            {!isAnySelected && (
              <button id="addNewBtn" onClick={handleAddNewClick}>
                Add New
              </button>
            )}
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th style={{ width: "1px" }}>
                <input type="checkbox" checked={isAllSelected} onChange={handleSelectAll} />
              </th>
              <th>S.No</th>
              <th>Code</th>
              <th>Name</th>
              <th>Cost Element</th>
              <th>Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={row.id}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(row.id)}
                    onChange={() => handleRowSelect(row.id)}
                  />
                </td>
                <td>{index + 1}</td>
                <td>{row.code}</td>
                <td>{row.name}</td>     
                <td></td>
                <td>{row.date}</td>
                <td>
                  <div className="actions">
                    <span className="edit-icon">
                      <img src={Vector} alt="Edit Icon" width="20" height="20" />
                    </span>
                    <span className="delete-icon">
                      <img src={Delete} alt="Delete Icon" width="40" height="40" />
                    </span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content" ref={popupRef}>
            <Popup closePopup={closePopup} />
          </div>
        </div>
      )}
    </>
  );
};

export default SubCostElement;